
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import TrinkgeldLogic from "@/logic/bestellung/trinkgeld_logic"

@Component({ components: { FilialeHeader, NichtGueltig } })
export default class Trinkgeld extends mixins(Calculator) {
  logic: TrinkgeldLogic = null

  mounted() {
    this.logic = new TrinkgeldLogic()
    this.logic.init()
  }

  weiter() {
    this.logic.weiter()
  }
}
